<template>
  <div>
    <h1>PAGINA DE PRODUCTORES</h1>
  </div>
</template>

<script>
export default {};
</script>
